import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21c4f528"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "company-record-input" }

import { useCompanyRecord } from '@/modules/company_record/CompanyRecord';
import AppInput from '@/core/components/form/AppInput.vue';
import AppButton from '@/core/components/form/AppButton.vue';

interface AppCompanyRecordInputProps {
	id: string,
	modelValue?: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppCompanyRecordInput',
  props: {
    id: {},
    modelValue: {}
  },
  emits: [
	'update:modelValue',
	'companyRecordResult',
],
  setup(__props: any, { emit: __emit }) {

const resource = useCompanyRecord();
const props = __props;

const emit = __emit;

const inputUpdated = (e) => {
	emit('update:modelValue', e.target.value);
};

const search = async () => {
	if (!props.modelValue || props.modelValue.length < 6) {
		return;
	}

	try {
		const companyRecord = await resource.search(props.modelValue as string);

		emit('companyRecordResult', companyRecord);
	} catch (e) {
		//
	}
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppInput, {
      type: "text",
      id: _ctx.id,
      value: _ctx.modelValue,
      onInput: inputUpdated
    }, null, 8, ["id", "value"]),
    _createVNode(AppButton, {
      seamless: "",
      icon: "search",
      onClick: _withModifiers(search, ["prevent"])
    }, null, 8, ["onClick"])
  ]))
}
}

})